export default "__VITE_PUBLIC_ASSET__d842c778__"